module.exports = __webpack_public_path__ + "img/promotion.2e702a16.png";